import DisplayDensityQuick from './components/DisplayDensityQuick';
import DisplayDensityFull from './components/DisplayDensityFull';
import { Option, OptionQuickCustomRenderComponentProps, QuickSettingOrder } from 'owa-options-core';
import { OwaWorkload } from 'owa-workloads';
import { isFeatureEnabled } from 'owa-feature-flags';
import * as React from 'react';
import { discardDensityOption } from './actions/internalActions';
import saveDensityOptionFullSettings from './actions/saveDensityOptionFullSettings';
import isDisplayDensityOptionDirty from './utils/isDisplayDensityOptionDirty';

const DisplayDensityOption: Option = {
    key: 'Density',
    titleStringKey: 'optionTitle_messageHeight',
    searchTermsStringKey: 'optionTitle_messageHeight',
    fullOptionFormSettings: {
        render: () => <DisplayDensityFull />,
        isDirty: isDisplayDensityOptionDirty,
        onSave: saveDensityOptionFullSettings,
        onDiscard: discardDensityOption,
    },
    quickOptionSettings: {
        rendering: {
            render: (props: OptionQuickCustomRenderComponentProps) => (
                <DisplayDensityQuick {...props} />
            ),
        },
        getOrder: () => QuickSettingOrder.DisplayDensity,
        workloads: OwaWorkload.Mail,
        customTitle: 'options_density_quickSetting_label',
        tooltip: {
            tooltipStringKey: 'options_density_quick_tooltip',
        },
    },
    isHidden: () => !isFeatureEnabled('tri-density-controls'),
};
export default DisplayDensityOption;
